import React, { useEffect, useMemo } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { usePostMessage } from 'src/contexts/message';

const messages = {
    unauthorised: 'Your session has expired',
    notFound: "This page doesn't exist!",
};

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (_e) {
        return true;
    }
}

export function RouteError() {
    const error = useRouteError();

    const message = useMemo(() => {
        if (isRouteErrorResponse(error)) {
            if (error.status === 404) {
                return messages.notFound;
            }

            if (error.status === 401) {
                return messages.unauthorised;
            }

            if (error.status === 503) {
                return 'Looks like our API is down';
            }

            if (error.status === 418) {
                return '🫖';
            }
        }

        if (error instanceof Error) {
            if (error.message === 'Unauthorized') {
                return messages.unauthorised;
            }
            if (error.message === 'Not Found') {
                return messages.notFound;
            }
        }

        return 'An error occured!';
    }, [error]);

    const postMessage = usePostMessage();

    useEffect(() => {
        postMessage({ message: 'myhealth-booking-ui-fatal', value: message });
    }, [message, postMessage]);

    if (inIframe()) {
        return <></>;
    }

    return (
        <div className="container mx-auto space-y-6 bg-white px-4 pb-12 pt-5 text-base">
            <FeaturedIcon size="lg" color="error" className="mb-8" />
            <h1 className="text-2xl font-medium text-gray-900">{message}</h1>
            {!window.parent && (
                <Button className="inline-block" href={import.meta.env.VITE_MYHEALTH_WEBSITE}>
                    Continue to Myhealth
                </Button>
            )}
        </div>
    );
}
